import { render, staticRenderFns } from "./TasksTableAssignableCell.vue?vue&type=template&id=c8071d0e&"
import script from "./TasksTableAssignableCell.vue?vue&type=script&lang=js&"
export * from "./TasksTableAssignableCell.vue?vue&type=script&lang=js&"
import style0 from "./TasksTableAssignableCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports